import Header from "@/components/Header";
import Hero from "@/components/Hero";
import FeaturedBooks from "@/components/FeaturedBooks";
import AboutWendy from "@/components/AboutWendy";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <FeaturedBooks />
        <AboutWendy />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
